/**
 * VibeSelector Component
 *
 * Step 1 of Parlay Workshop - User selects their parlay "vibe"
 * Options: Safe, Smart, Hot, Surprise Me
 */

import React from 'react';

const VIBES = [
  {
    id: 'safe',
    emoji: '🐢',
    name: 'SAFE',
    oddsRange: '+150-250',
    description: 'High confidence picks',
    color: 'from-green-500/20 to-green-600/10',
    borderColor: 'border-green-500/30',
    hoverBorder: 'hover:border-green-500/60'
  },
  {
    id: 'smart',
    emoji: '🎯',
    name: 'SMART',
    oddsRange: '+250-400',
    description: 'Best value picks',
    color: 'from-blue-500/20 to-blue-600/10',
    borderColor: 'border-blue-500/30',
    hoverBorder: 'hover:border-blue-500/60'
  },
  {
    id: 'hot',
    emoji: '🔥',
    name: 'HOT',
    oddsRange: '+400+',
    description: 'Hot streaks & YOLO',
    color: 'from-orange-500/20 to-orange-600/10',
    borderColor: 'border-orange-500/30',
    hoverBorder: 'hover:border-orange-500/60'
  },
  {
    id: 'surprise',
    emoji: '🎲',
    name: 'SURPRISE ME',
    oddsRange: '???',
    description: "Knewton's choice",
    color: 'from-purple-500/20 to-purple-600/10',
    borderColor: 'border-purple-500/30',
    hoverBorder: 'hover:border-purple-500/60'
  }
];

export default function VibeSelector({ onSelect }) {
  return (
    <div className="glass-card p-6">
      <h2 className="text-xl font-semibold text-text-primary mb-2">
        What kind of parlay are we building today?
      </h2>
      <p className="text-text-secondary text-sm mb-6">
        Select your risk tolerance and Knewton will tailor recommendations
      </p>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {VIBES.map((vibe) => (
          <button
            key={vibe.id}
            onClick={() => onSelect(vibe.id)}
            className={`
              relative p-6 rounded-xl border-2 transition-all duration-300
              bg-gradient-to-br ${vibe.color}
              ${vibe.borderColor} ${vibe.hoverBorder}
              hover:scale-105 hover:shadow-lg
              focus:outline-none focus:ring-2 focus:ring-accent-blue/50
            `}
          >
            {/* Emoji */}
            <div className="text-4xl md:text-5xl mb-3">{vibe.emoji}</div>

            {/* Name */}
            <div className="text-lg font-bold text-text-primary mb-1">
              {vibe.name}
            </div>

            {/* Odds Range */}
            <div className="text-sm font-mono text-accent-blue mb-2">
              {vibe.oddsRange}
            </div>

            {/* Description */}
            <div className="text-xs text-text-secondary">
              {vibe.description}
            </div>
          </button>
        ))}
      </div>

      {/* Knewton's tip */}
      <div className="mt-6 p-4 bg-bg-card/50 rounded-lg border border-border">
        <div className="flex items-start gap-3">
          <span className="text-2xl">🤖</span>
          <div>
            <p className="text-sm text-text-secondary">
              <span className="font-semibold text-text-primary">Knewton says: </span>
              Not sure? Start with <span className="text-accent-blue font-medium">Smart</span> -
              I'll find you the best value plays based on our data.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
